module.exports = __webpack_public_path__ + "img/sound.8d381bfa.svg";